var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"feature-list",class:{'disabled' : !_vm.feature.value},attrs:{"sm4":"","xs6":"","md3":""}},[_c('span',[_c('span',{class:_vm.feature.icon}),_vm._v(" "+_vm._s(_vm.$t("features."+_vm.index)))])])}
var staticRenderFns = []

export { render, staticRenderFns }